module.exports = __webpack_public_path__ + "img/icon_setting_down.7138fa44.svg";